import { render, staticRenderFns } from "./SiteMvrChecksList.vue?vue&type=template&id=50ce3ab3&scoped=true"
import script from "./SiteMvrChecksList.vue?vue&type=script&lang=js"
export * from "./SiteMvrChecksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce3ab3",
  null
  
)

export default component.exports